import { render, staticRenderFns } from "./tabelaAgrupamentos.vue?vue&type=template&id=6e0c627f&scoped=true"
import script from "./tabelaAgrupamentos.vue?vue&type=script&lang=js"
export * from "./tabelaAgrupamentos.vue?vue&type=script&lang=js"
import style0 from "./tabelaAgrupamentos.vue?vue&type=style&index=0&id=6e0c627f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0c627f",
  null
  
)

export default component.exports